export default "__VITE_ASSET__IynpsS2U__"